/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { MetaData } from "../Courses/GetAllRequests";
export type ContactUsDTO = {
  id: string;
  email: string;
  name: string;
  phone: string;
  message:string;
  createdAt: string;
}


interface ContactUsData {
  contactUs: ContactUsDTO[];
  metaData: MetaData;
}

interface ContactUsResponse {
  data?: ContactUsData;
  error?: ApiError;
}

interface GetContactUsParams {
  page: number;
  limit: number;
}

export const getAllContactUs = async ({ page, limit }: GetContactUsParams): Promise<ContactUsResponse> => {
  try {
    const response = await axios.get(`/contact-us/all`, {
      params: { page, limit },
    });
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
